import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../../components/form/FormInput';
import { getValidationObject } from '../../../../../constants/regexPatterns';
import { createCompanyCustomDomain, selectCompanyCustomDomainCreatingLoading } from '../../../../../redux/modules/company';

const RegisterDomainModal = ({ companyId }) => {
  const dispatch = useDispatch();
  const domainCreatingLoading = useSelector(selectCompanyCustomDomainCreatingLoading);

  const useFormMethods = useForm();
  const { handleSubmit } = useFormMethods;

  const onSubmit = async data => {
    const domain = data['register-domain-input'];

    dispatch(createCompanyCustomDomain(companyId, domain));
  };

  return (
    <Box>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <form dusk="register-domain-form" id="registerDomainForm" onSubmit={handleSubmit(onSubmit)}>
        <Text color="greyScale.700" mb={2} textStyle="bodyMd">
          Please provide the domain you&apos;d like to register.
          This is likely the domain that comes after the &apos;@&apos; symbol
          of your email address.
        </Text>
        <FormInput
          required
          inputName="register-domain-input"
          key="register-domain-input"
          labelName="Domain Name"
          placeholder="yourdomainexample.com"
          useFormMethods={useFormMethods}
          validationRules={getValidationObject('domain')}
        />

        <Button
          form="registerDomainForm"
          isLoading={domainCreatingLoading}
          mt={4}
          type="submit"
        >
          Register Domain
        </Button>
      </form>
    </Box>
  );
};

RegisterDomainModal.propTypes = { companyId: PropTypes.number.isRequired };

export default RegisterDomainModal;
